<template>
  <div class="app-toolbar">
    <slot name="title"></slot>
    <div class="space"></div>
    <slot name="actions"></slot>
  </div>
</template>

<script>
export default {
  name: 'AppToolbar',
}
</script>

<style lang="scss" scoped>
.app-toolbar {
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;

  .space {
    flex: 1;
  }
}
</style>
